import { WorkflowStatusProvider } from '../WorkflowStatus/WorkflowStatusProvider'
import { WorkflowStatus } from '../WorkflowStatus/WorkflowStatus'
import { AssigneeType, Property, SelectPropertyValue } from 'api/clients/PropertyClient'
import { Workflow } from 'stores/Workflows/Workflow'
import { IWorkflow } from 'stores/Workflows/Types'
import { useArticle } from 'hooks/queries/articles/useArticle'
import { Permission } from 'types'

interface Props {
  articleId: string
  property: Property<SelectPropertyValue>
  workflow: Workflow
  folder: IWorkflow['folder']
}

export const ArticleWorkflowPropertyValue = ({ articleId, workflow, folder, property }: Props) => {
  const { data } = useArticle(articleId)
  const assignee = { id: articleId, type: AssigneeType.Article }
  const permissions = data?.article?.almanac_file.permissions || {
    can_transition_to: [],
    can_read: false,
    can_edit: false,
    can_edit_content: false,
    access: Permission.Read,
  }

  return (
    <WorkflowStatusProvider
      workflow={workflow}
      assignee={assignee}
      property={property}
      folder={folder}
      permissions={permissions}
    >
      <WorkflowStatus />
    </WorkflowStatusProvider>
  )
}
